import { IAvailability } from './availability.interface';

export enum ResourceTypeEnum {
  TAN_BOOTH = 'tan-booth',
}

// Hebrew display labels for equipment types (UI chips, pickers).
export const resourceTypeNames: Record<ResourceTypeEnum, string> = {
  [ResourceTypeEnum.TAN_BOOTH]: 'תא שיזוף',
};

// A bookable, non-staff entity (e.g. a tanning booth). Unlike a provider it has no
// person attached; it carries its own working hours and concurrency capacity.
export interface IResource {
  id: string;
  name: string;
  type: ResourceTypeEnum;
  // Weekly working hours for this resource, reusing the provider availability model.
  // Empty = falls back to the branch working hours.
  availability: IAvailability;
  // How many people can use this resource concurrently (number of physical units).
  capacity: number;
  visible: boolean;
  // Branch this resource belongs to. Undefined = main/default branch (single-location).
  branchId?: string;
}
